import styled from 'styled-components';
import { Modal } from 'antd';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    position: relative; overflow: hidden; border-radius: 22px;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45);
  }
  .ant-modal-body { padding: 0; }

  button { padding: 0; border: none; background: transparent; cursor: pointer; }

  .close {
    position: absolute; top: 18px; right: 20px; z-index: 1;
    display: flex; align-items: center; justify-content: center;
    width: 26px; height: 26px; border-radius: 6px;
    color: #b9bcc2; font-size: 20px; line-height: 1;
    transition: color 0.15s ease, background 0.15s ease;
    &:hover { color: #6b6e75; background: #f1f2f4; }
  }

  .content {
    display: flex; flex-direction: column; align-items: center;
    padding: 44px 56px 34px; font-family: 'Inter', sans-serif; text-align: center;
  }

  .brand {
    font-family: 'Poppins', sans-serif; font-weight: 700; font-size: 22px;
    letter-spacing: -0.5px; color: #1b1b1f;
  }

  .thanks {
    margin: 10px 0 0;
    font-size: 15px; font-weight: 400; color: #97836a;
  }

  .invite {
    margin: 6px 0 0; max-width: 420px;
    font-family: 'Poppins', sans-serif; font-weight: 600; font-size: 19px;
    line-height: 1.35; color: #24242a; text-wrap: balance;
  }

  .google-logo { margin: 26px 0 30px; }

  .review {
    display: flex; align-items: center; justify-content: center; gap: 10px;
    box-sizing: border-box; width: 100%; padding: 15px 24px; border-radius: 10px;
    background: #101014;
    font-family: 'Poppins', sans-serif; font-size: 15px; font-weight: 600;
    color: #ffffff;
    transition: filter 0.15s ease, transform 0.12s ease;
    &:hover { filter: brightness(1.25); transform: translateY(-1px); }
  }

  .later {
    margin-top: 18px; padding: 6px 4px;
    font-size: 13.5px; font-weight: 400; color: #9a9da3;
    transition: color 0.15s ease;
    &:hover { color: #6b6e75; }
  }

  @media (max-width: 480px) {
    .content { padding: 38px 24px 28px; }
    .invite { font-size: 17px; }
  }
`;
